module.exports = __webpack_public_path__ + "img/高效便捷@2x.5a099360.png";